import { isServiceCategoryId } from '@powerful/config/categories';
import { z } from 'zod';

// T2.2: o formato não basta — `favorite_categories` só aceita IDs do catálogo (o banco recusa o resto).
const categoryId = z.string().uuid().refine(isServiceCategoryId, { message: 'Categoria desconhecida.' });

export const consumerProfileSchema = z
  .object({
    favorite_categories: z.array(categoryId).default([]).refine((ids) => new Set(ids).size === ids.length, {
      message: 'Categorias favoritas não podem repetir-se.',
    }),
    city: z.string().trim().min(1).max(120).optional(),
    geo: z
      .object({
        latitude: z.number().min(-90).max(90),
        longitude: z.number().min(-180).max(180),
      })
      .strict()
      .optional(),
    marketing_opt_in: z.boolean().default(false),
  })
  .strict();

export type ConsumerProfileInput = z.input<typeof consumerProfileSchema>;
export type ConsumerProfileData = z.output<typeof consumerProfileSchema>;
